import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function GraphicIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "20"}
      viewBox="0 0 20 20"
    >
      <g id="Dashboard" transform="translate(-26 -82)">
        <path
          id="Path_10013"
          data-name="Path 10013"
          d="M9.667,18.556H7.444V10.778H9.667Zm4.444,0H11.889V7.444h2.222Zm4.444,0H16.333V14.111h2.222Zm2.222,2.222H5.222V5.222H20.778ZM20.778,3H5.222A2.229,2.229,0,0,0,3,5.222V20.778A2.229,2.229,0,0,0,5.222,23H20.778A2.229,2.229,0,0,0,23,20.778V5.222A2.229,2.229,0,0,0,20.778,3Z"
          transform="translate(23 79)"
          fill={color || "#bbb"}
        />
      </g>
    </svg>
  );
}
